module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map",
    style: ({
      'background': 'url( ' + _vm.image + ' ) ',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      backgroundPosition: 'center top'
    })
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row flex-vertical-align-center"
  }, [_c('div', {
    staticClass: "element col-l-12 col-m-12 col-s-12"
  }, [_c('div', {
    staticClass: "map__content",
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0bda535e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlockMap.vue
// module id = 309
// module chunks = 0